import { Badge } from '@awaze/design-system.components.badge'
import { Link } from '@awaze/design-system.components.link'
import { pxToRems } from '@awaze/design-system.utils.react'
import { BlogTag } from './mapBlogTag'
import styled from 'styled-components'

const BlogTagsContainer = styled.div<{ center?: boolean }>`
  margin-top: ${pxToRems(24)};
  display: inline-flex;
  flex-wrap: wrap;
  ${(props) => props.center && `justify-content: center;`}
  gap: ${pxToRems(16)};
  .blog-tag {
    padding: ${pxToRems(4)} ${pxToRems(16)};
    color: ${({ theme }) => theme.ColorButtonOutlineSecondaryTextHover};
  }
`

export default function BlogTags({
  tags,
  center,
}: Readonly<{
  tags: BlogTag[]
  center?: boolean
}>): JSX.Element {
  return (
    <BlogTagsContainer center={center}>
      {tags.map(({ tagName, tagSlug }) => (
        <Link key={tagName} href={tagSlug}>
          <Badge
            className="blog-tag"
            colourScheme="tertiary"
            text={tagName}
            variant="outline"
          />
        </Link>
      ))}
    </BlogTagsContainer>
  )
}
